// ASSETS

// STYLES
import {
  AboutPageContainer,
  SectionContainer,
  SectionsRow2,
} from "./AboutPageStyled";

// LIBRARIES

// MISC
import { IProps, PageSection } from "./AboutPageModel";

// REDUX

// COMPONENTS
import CardsSection from "./CardsSection/CardsSection";
import MissionSection from "./MissionSection/MissionSection";
import PersonnelSection from "./PersonnelSection/PersonnelSection";
import ProjectsSection from "./ProjectsSection/ProjectsSection";
import PartnersSection from "./PartnersSection/PartnersSection";
import ReportsSection from "./ReportsSection/ReportsSection";
import OrganizeSection from "./OrganizeSection/OrganizeSection";
import ManagementSection from "./ManagementSection/ManagementSection";

const AboutPage = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <AboutPageContainer>
      <SectionsRow2>
      <SectionContainer
        section={PageSection.ORGANIZE}
        id={PageSection.ORGANIZE}
      >
        <OrganizeSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.ATTRIBUTIONS}
        id={PageSection.ATTRIBUTIONS}
      >
        <CardsSection />
      </SectionContainer>
      <SectionContainer section={PageSection.MISSION} id={PageSection.MISSION}>
        <MissionSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PERSONNEL}
        id={PageSection.PERSONNEL}
      >
        <PersonnelSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PROJECTS}
        id={PageSection.PROJECTS}
      >
        <ProjectsSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.PARTNERS}
        id={PageSection.PARTNERS}
      >
        <PartnersSection />
      </SectionContainer>
      <SectionContainer section={PageSection.REPORTS} id={PageSection.REPORTS}>
        <ReportsSection />
      </SectionContainer>
      <SectionContainer
        section={PageSection.MANAGEMENT}
        id={PageSection.MANAGEMENT}
      >
        <ManagementSection />
      </SectionContainer>
      </SectionsRow2>
    </AboutPageContainer>
  );
};

export default AboutPage;
